export const QUESTION_DATA = [
  {
    id: 1,
    category: "취침 시간",
    question: "보통 몇 시에 잠에 드나요?",
    options: [
      { id: "A", text: "보통 밤 12시 ~ 1시 사이에 잠들어요" },
      { id: "B", text: "보통 새벽 1시 ~ 2시 사이에 잠들어요" },
      { id: "C", text: "보통 새벽 2시 ~ 3시 사이에 잠들어요" },
      { id: "D", text: "보통 새벽 3시 이후에 잠들어요" },
      { id: "E", text: "다른 의견이 있어요"},
    ],
  },

  {
    id: 2,
    category: "기상 시간",
    question: "보통 몇 시에 일어나나요?",
    options: [
      { id: "A", text: "보통 오전 7시~8시 사이에 일어나요" },
      { id: "B", text: "보통 오전 8시~9시 사이에 일어나요" },
      { id: "C", text: "보통 오전 9시~10시 사이에 일어나요" },
      { id: "D", text: "그때그때 달라요" },
      { id: "E", text: "다른 의견이 있어요"},
    ],
  },

  {
    id: 3,
    category: "소등 시간",
    question: " 방 불은 언제 끄면 좋을까요?",
    options: [
      { id: "A", text: "한 명이라도 잠들면 불을 꺼요" },
      { id: "B", text: "밤 12시에 불을 꺼요" },
      { id: "C", text: "새벽 1시에 불을 꺼요" },
      { id: "D", text: "모두 잠들 때 불을 꺼요" },
      { id: "E", text: "다른 의견이 있어요"},
    ],
  },

  {
    id: 4,
    category: "취침 시 소음",
    question: "자고 있을 때, 이런 소음은 조심해 주세요!",
    options: [
      { id: "A", text: "영상 시청은 이어폰을 사용해요"},
      { id: "B", text: "전화 통화는 방 밖에서 해요"},
      { id: "C", text: "늦은 시간에는 키보드·마우스 소리를 줄여요"},
      { id: "D", text: "늦게 들어올 때는 조용히 들어와요"},
      { id: "E", text: "코골이·이갈이에 서로 배려해요"},
    ],
  },

  {
    id: 5,
    category: "알람",
    question: "알람은 이렇게 맞추면 좋겠어요!",
    options: [
      { id: "A", text: "알람은 본인만 들을 수 있게 작은 소리로 맞춰요" },
      { id: "B", text: "서로의 알람 소리가 들리면 깨워줘요" },
      { id: "C", text: "알람은 최대 3번까지 허용해요" },
      { id: "D", text: "알람은 진동으로 맞춰요" },
      { id: "E", text: "다른 의견이 있어요"}, 
    ],
  },
  
];
